import React, { useEffect } from "react";
import { scrollToTop } from "../common/GeneralMethod";
import Header from "../common/Header";
import Footer from "../common/Footer";
import LogoContent from "../common/LogoContent";

const ServiceLevelAgreement = ({Header}) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div>
      {/* Header */}
      {Header!=="No" ?<header className="navbar-light header-sticky">
        <nav className="navbar navbar-expand-xl">
          <div className="container">
            <LogoContent />
          </div>
        </nav>
      </header>:null}
      

      {/* Main Content */}
      <main>
        <div className="container my-5 py-3">
          <h3 className="mb-4">Service Level Agreement</h3>
          <p><strong>PLEASE READ AND UNDERSTAND THIS SERVICE LEVEL AGREEMENT BEFORE USING CABKRO APPLICATIONS.</strong></p>
          <p>By continuing to use our website, you agree to comply with and be bound by the following terms, governing the relationship between Cabkro and you, the "Vendor/Driver."</p>

          <h6>1. Agreement Overview</h6>
          <p>1.1 Cabkro provides services to generate leads for transportation providers. Requests from users of Cabkro’s platforms are transferred to authorised transportation providers ("Vendor/Driver") who receive and fulfil these requests.</p>
          <p>1.2 The Vendor/Driver acknowledges that Cabkro is solely a technology platform and does not provide transportation services or act as a carrier.</p>

          <h6>2. Terms and Conditions</h6>
          <p>2.1 Cabkro and the Vendor/Driver agree to the following terms.</p>

          <h6>3. Definitions</h6>
          <p>3.1 "Driver" means a person authorised by Cabkro to offer cab services through its platform.</p>
          <p>3.2 "Users" are individuals aged 18 or above using Cabkro applications to request cab services.</p>
          <p>3.3 "Vehicle" means any approved car, van, or mini bus used by a Driver to fulfil cab services.</p>

          <h6>4. Vendor/Driver Relationship with Users</h6>
          <p>4.1 The Vendor is fully responsible for their legal obligations with Users. Cabkro is not liable for any actions of the Users.</p>
          <p>4.2 Vendors are responsible for handling disputes with Users. Cabkro may assist but is not responsible for the outcome.</p>

          <h6>5. Vendor's Relationship with Cabkro</h6>
          <p>5.1 Vendors are independent contractors. This agreement does not create any partnership or employment relationship.</p>
          <p>5.2 Cabkro may restrict access to its platform in case of policy violation or brand harm.</p>

          <h6>6. Vendor's Relationship with Drivers</h6>
          <p>6.1 Vendors must manage their Drivers and ensure compliance with applicable laws.</p>
          <p>6.2 Honest feedback and service reviews must be ensured by Vendors.</p>

          <h6>7. Drivers and Vehicle Requirements</h6>
          <p>7.1 Drivers must hold valid documents and follow hygiene, safety, and legal guidelines.</p>
          <p>7.2 Vehicles must be roadworthy, clean, and appropriately registered.</p>
          <p>7.3 Vendors are responsible for submitting valid documentation to Cabkro.</p>

          <h6>8. Payment Policy and Fare Adjustment</h6>
          <p>8.1 Cabkro can revise its pricing or introduce new service fees.</p>
          <p>8.2 Vendors must accept user payments directly.</p>
          <p>8.3 Cabkro reserves the right to penalise service failures and adjust fares accordingly.</p>

          <h6>9. Membership</h6>
          <p>9.1 Membership may offer benefits but does not guarantee increased bookings. Fees are non-refundable.</p>
          <p>9.2 Cabkro can modify or cancel memberships at its discretion.</p>

          <h6>10. Taxes</h6>
          <p>10.1 Vendors are responsible for handling their tax liabilities and submitting related details to Cabkro if requested.</p>

          <h6>11. Intellectual Property</h6>
          <p>11.1 All intellectual property rights of Cabkro, including logos and trademarks, remain owned by Cabkro. Use of branding without consent is prohibited.</p>

          <h6>12. Term and Termination</h6>
          <p>12.1 The agreement is effective upon acceptance and continues until terminated by either party.</p>
          <p>12.2 Either party may terminate the agreement with 7 days’ notice or immediately in case of material breach.</p>

          <h6>13. Indemnity</h6>
          <p>13.1 Vendors agree to indemnify and protect Cabkro from claims or liabilities arising from the use of the service or violation of this agreement.</p>

          <h6>14. Jurisdiction</h6>
          <p>14.1 This agreement is governed by Indian laws. All disputes will be resolved via arbitration in New Delhi, India.</p>

          <h6>15. Disclaimer, Limitation of Liability, and Indemnity</h6>
          <p>15.1 Cabkro provides services "as is" without warranties of any kind. It is not liable for any indirect or consequential damages. Vendors agree to indemnify Cabkro from all losses and liabilities.</p>

          <p className="mt-4"><strong>By using Cabkro’s services, you agree to the terms outlined in this Service Level Agreement.</strong></p>
        </div>
      </main>

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
};

export default ServiceLevelAgreement;
